module.exports = __webpack_public_path__ + "img/giftbox_358x320@1x.ff02e89.jpg";